// 路由路径常量
export const ROUTES = {
  // 认证相关
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  
  // 主页面
  HOME: '/',
  DASHBOARD: '/dashboard',
  
  // 客户模块
  CUSTOMERS: '/customers',
  CUSTOMER_DETAIL: '/customers/:id',
  
  // 提案模块
  PROPOSALS: '/proposals',
  PROPOSAL_DETAIL: '/proposals/:id',
  PROPOSAL_NEW: '/proposals/new',
  
  // 星探模块
  SCOUT: '/scout',
  SCOUT_SEARCH: '/scout/search',
  SCOUT_INFLUENCER: '/scout/influencers/:id',
  SCOUT_SCREENING: '/scout/screening',
  
  // 邀约模块
  OUTREACH: '/outreach',
  OUTREACH_CAMPAIGNS: '/outreach/campaigns',
  OUTREACH_CAMPAIGN_DETAIL: '/outreach/campaigns/:id',
  OUTREACH_REPLIES: '/outreach/replies',
  OUTREACH_REPLY_DETAIL: '/outreach/replies/:id',
  OUTREACH_EMAIL_ACCOUNTS: '/outreach/email-accounts',
  
  // 知识库
  KNOWLEDGE: '/knowledge',
  
  // 通知中心
  NOTIFICATIONS: '/notifications',
  
  // 个人设置
  PROFILE: '/profile',
  
  // 系统设置
  SETTINGS: '/settings',
  SETTINGS_TENANT: '/settings/tenant',
  SETTINGS_MEMBERS: '/settings/members',
  SETTINGS_ROLES: '/settings/roles',
  SETTINGS_SUBSCRIPTION: '/settings/subscription',
  SETTINGS_USAGE: '/settings/usage',
  SETTINGS_BILLING: '/settings/billing',
  SETTINGS_PAYMENT: '/settings/payment',
  SETTINGS_DATA_EXPORT: '/settings/data-export',
  SETTINGS_ACCOUNT_LIFECYCLE: '/settings/account-lifecycle',
  
  // 管理后台
  ADMIN: '/admin',
  ADMIN_TENANTS: '/admin/tenants',
  ADMIN_TENANT_DETAIL: '/admin/tenants/:id',
  ADMIN_ANNOUNCEMENTS: '/admin/announcements',
  
  // 404
  NOT_FOUND: '*',
} as const;

// 侧边栏菜单配置
export const MENU_ITEMS = [
  {
    key: 'dashboard',
    label: '工作台',
    path: ROUTES.DASHBOARD,
    icon: 'DashboardOutlined',
  },
  {
    key: 'proposals',
    label: '提案中心',
    path: ROUTES.PROPOSALS,
    icon: 'FileTextOutlined',
    children: [
      { key: 'proposal-list', label: '提案列表', path: ROUTES.PROPOSALS },
    ],
  },
  {
    key: 'scout',
    label: '红人星探',
    path: ROUTES.SCOUT,
    icon: 'SearchOutlined',
    children: [
      { key: 'scout-search', label: '红人搜索', path: ROUTES.SCOUT_SEARCH },
      { key: 'scout-screening', label: '筛选任务', path: ROUTES.SCOUT_SCREENING },
    ],
  },
  {
    key: 'outreach',
    label: '红人邀约',
    path: ROUTES.OUTREACH,
    icon: 'MailOutlined',
    children: [
      { key: 'outreach-campaigns', label: '邀约活动', path: ROUTES.OUTREACH_CAMPAIGNS },
      { key: 'outreach-replies', label: '回复监测', path: ROUTES.OUTREACH_REPLIES },
      { key: 'outreach-email-accounts', label: '渠道账号', path: ROUTES.OUTREACH_EMAIL_ACCOUNTS },
    ],
  },
  {
    key: 'knowledge',
    label: '知识库',
    path: ROUTES.KNOWLEDGE,
    icon: 'BookOutlined',
  },
  {
    key: 'settings',
    label: '设置',
    path: ROUTES.SETTINGS,
    icon: 'SettingOutlined',
    children: [
      { key: 'settings-tenant', label: '租户设置', path: ROUTES.SETTINGS_TENANT },
      { key: 'settings-members', label: '成员管理', path: ROUTES.SETTINGS_MEMBERS },
      { key: 'settings-roles', label: '角色权限', path: ROUTES.SETTINGS_ROLES },
      { key: 'settings-subscription', label: '订阅管理', path: ROUTES.SETTINGS_SUBSCRIPTION },
      { key: 'settings-usage', label: '用量统计', path: ROUTES.SETTINGS_USAGE },
      { key: 'settings-billing', label: '账单管理', path: ROUTES.SETTINGS_BILLING },
      { key: 'settings-data-export', label: '数据导出', path: ROUTES.SETTINGS_DATA_EXPORT },
      { key: 'settings-account-lifecycle', label: '账户管理', path: ROUTES.SETTINGS_ACCOUNT_LIFECYCLE },
    ],
  },
];

// 路由权限映射
export const ROUTE_PERMISSIONS: Record<string, string[]> = {
  [ROUTES.DASHBOARD]: ['owner', 'admin', 'operator', 'viewer'],
  [ROUTES.PROPOSALS]: ['owner', 'admin', 'operator', 'viewer'],
  [ROUTES.PROPOSAL_NEW]: ['owner', 'admin', 'operator'],
  [ROUTES.SCOUT]: ['owner', 'admin', 'operator'],
  [ROUTES.SCOUT_SEARCH]: ['owner', 'admin', 'operator'],
  [ROUTES.OUTREACH]: ['owner', 'admin', 'operator'],
  [ROUTES.OUTREACH_CAMPAIGNS]: ['owner', 'admin', 'operator'],
  [ROUTES.OUTREACH_REPLIES]: ['owner', 'admin', 'operator'],
  [ROUTES.OUTREACH_EMAIL_ACCOUNTS]: ['owner', 'admin', 'operator'],
  [ROUTES.KNOWLEDGE]: ['owner', 'admin', 'operator', 'viewer'],
  [ROUTES.SETTINGS]: ['owner', 'admin'],
  [ROUTES.SETTINGS_TENANT]: ['owner', 'admin'],
  [ROUTES.SETTINGS_MEMBERS]: ['owner', 'admin'],
  [ROUTES.SETTINGS_ROLES]: ['owner', 'admin'],
  [ROUTES.SETTINGS_SUBSCRIPTION]: ['owner'],
  [ROUTES.SETTINGS_USAGE]: ['owner', 'admin'],
  [ROUTES.SETTINGS_BILLING]: ['owner'],
  [ROUTES.SETTINGS_PAYMENT]: ['owner'],
  [ROUTES.SETTINGS_DATA_EXPORT]: ['owner', 'admin'],
  [ROUTES.SETTINGS_ACCOUNT_LIFECYCLE]: ['owner'],
  
  // 个人设置（所有角色）
  [ROUTES.PROFILE]: ['owner', 'admin', 'operator', 'viewer'],
  
  // 管理后台（仅超管）
  [ROUTES.ADMIN]: ['super_admin'],
  [ROUTES.ADMIN_TENANTS]: ['super_admin'],
  [ROUTES.ADMIN_TENANT_DETAIL]: ['super_admin'],
  [ROUTES.ADMIN_ANNOUNCEMENTS]: ['super_admin'],
};
